<template>
  <div v-if="isLoading">
    <div v-if="small">
      <b-spinner small :class="[labelEnabled ? 'mr-2' : '']"></b-spinner>
      {{getLabel}}
    </div>
    <div v-else class="divLoader h-100">
      <div class="row h-100 justify-content-center align-items-center">
        <b-spinner></b-spinner>
      </div>
      <p v-if="labelEnabled" id="labelLoader">{{getLabel}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: false,
    small: {
      type: Boolean,
      default: false
    },
    labelEnabled: {
      type: Boolean,
      default: true
    },
    label: {
      type: String
    }
  },
  computed: {
    getLabel() {
      if (!this.labelEnabled) return "";
      if (
        this.label != null &&
        this.label != undefined &&
        this.label.length > 0
      )
        return this.label;
      return this.small ? "Aguarde..." : "Carregando";
    }
  }
};
</script>

<style scoped>
.divLoader {
  padding: 2rem;
}
#labelLoader {
  padding-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Loader.vue